<mat-progress-bar *ngIf="loggedIn" mode="indeterminate"></mat-progress-bar>
<p *ngIf="!loggedIn">Sorry something went wrong while we're trying to authenticate you</p>
